import { useAuth } from "../../context/global";
import { useEffect } from "react";
import { Typography } from "@mui/material";

const Home = function () {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Início");
    }, [setTitlePage]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
            }}
        >
            <Typography variant="h5">BEM VINDO!</Typography>
        </div>
    );
};

export default Home;
